import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { UserProvider } from './context/user';
import { SessionProvider } from './components/SessionProvider';
import { OverViewPage } from './pages/OverviewPage';
import { Taxpayer } from './pages/Taxpayer';
import { Login } from './pages/Login';
import { DashboardPage } from './pages/Dashboard';
import { AdminControl } from './pages/AdminControl';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Permission } from './pages/Permission';
import { ServiceProvider } from './pages/ServiceProvider';
import { Logs } from './pages/Logs';
import { LookupManagement } from './pages/LookupManagement';
import { AuditLogPage } from './pages/AuditLog'
import {CertificatesPage} from "./pages/Certificates";
import {ForgotPassword} from "./pages/ForgotPassword";
import { SystemSettings } from './pages/SystemSettings';
import { DISABLED_FEATURE_TABS } from './constants/common';
const App = () => {
  return (
    <BrowserRouter>
      <UserProvider>
        <SessionProvider>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route exact path={`/dashboard`} element={<DashboardPage tab="dashboard"/>} />
              <Route exact path={`/forgotPassword`} element={<ForgotPassword tab="forgotPassword"/>} />
              <Route path={`/invoices`} element={<OverViewPage tab="invoices" />} />
            <Route path={`/taxpayers`} element={<Taxpayer tab="invoices" />} />
            <Route path='/admin_control' element={<AdminControl tab='admin_control'/>}/>
            <Route path='/permissions' element={<Permission tab='permissions'/>}/>
            <Route path='/service_providers' element={DISABLED_FEATURE_TABS.includes('service_providers') ? <Navigate to="/dashboard" replace/> : <ServiceProvider tab='service_providers'/>}/>
            <Route path='/logs' element={<Logs tab='logs'/>}/>
            <Route path='/lookup_management' element={<LookupManagement tab='lookup_management'/>}/>
            <Route path='/audit_log' element={<AuditLogPage tab='audit_log'/>}/>
            <Route path='/system_settings' element={<SystemSettings tab='system_settings'/>}/>
            <Route path='/certificates' element={DISABLED_FEATURE_TABS.includes('certificates') ? <Navigate to="/dashboard" replace/> : <CertificatesPage tab='certificates'/>}/>
            <Route path="/login" element={<Login />} replace />
          </Routes>
        </SessionProvider>
        <ToastContainer hideProgressBar newestOnTop={false} closeOnClick position="top-right" autoClose={3000} theme="colored" />
      </UserProvider>
    </BrowserRouter>
  );
}

export default React.memo(App);
